/**
 * 模組代碼 : -
 * 模組說明 : (共用模組) 密碼輸入欄位
 * @module web/components/PasswordInput
 */

// ----- import from npm modules -----
import React, { useState, useRef, useEffect } from 'react';

function PasswordInput({ id, name, value, oldValue, confirmValue, onChange, validateType, defaultMassage, resetMessage, setResetMessage, size = 'sm' }) {
    const inputRef = useRef();
    const [showPassword, setShowPassword] = useState(false);
    const [validationMessage, setValidationMessage] = useState('');

    const handleTogglePasswordVisibility = () => {
        setShowPassword(prevShowPassword => !prevShowPassword); 
    };

    const validateLoginPassword = (value) => {
        /*const password = value.toString().trim();
        if (password === '') {
            return '密碼不可為空';
        }*/
        return '';
    };

    const validateNewPassword = (value, oldValue, confirmValue) => {
        const password = value.toString().trim();
        const oldPassword = oldValue !== null? oldValue.toString().trim() : null;
        const confirmPassword = confirmValue !== null? confirmValue.toString().trim() : null;

        if (!password) {
            return '新密碼不可為空';
        }

        if (password) {
            if (oldPassword !== null && password === oldPassword) {
                return '新密碼不可與舊密碼相同';
            }

            if ((confirmPassword !== null && confirmPassword !== '') && password !== confirmPassword) {
                return '與確認密碼不符';
            }

            const isLengthValid = password.length >= 8 && password.length <= 16;
            const hasUpperCase = /[A-Z]/.test(password);
            const hasLowerCase = /[a-z]/.test(password);
            const hasNumber = /\d/.test(password);
            const hasSpecialChar = /[!@#$%^&*()_`+\.\-=\[\]:';"<>/?,]/.test(password);

            const isPasswordValid = isLengthValid && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;

            if (!isPasswordValid) {
                return '密碼長度為8-16碼，至少包含1個以上大寫英文、小寫英文、數字、符號';
            }
        }
        return '';
    };

    const validateConfirmPassword = (value, confirmValue) => {
        const confirmPassword = value.toString().trim();
        const newPassword = confirmValue.toString().trim();
        if (!confirmPassword) {
            return '確認密碼不可為空';
        }

        if (confirmPassword && newPassword && confirmPassword !== newPassword) {
            return '請確認與輸入密碼相符';
        }

        return '';
    };

    const validateOldPassword = (value, confirmValue) => {
        const oldPassword = value.toString().trim();
        const newPassword = confirmValue.toString().trim();
        if (!oldPassword) {
            return '舊密碼不可為空';
        }
        if (oldPassword && newPassword && oldPassword === newPassword) {
            return '與新密碼相同';
        }
        return '';
    };

    const validatePassword = (value, oldValue, confirmValue, validateType) => {
        switch (validateType) {
            case 'login':
                return validateLoginPassword(value);
            case 'password':
                return validateNewPassword(value, null, confirmValue);
            case 'newPassword':
                return validateNewPassword(value, oldValue, confirmValue);
            case 'confirmPassword':
                return validateConfirmPassword(value, confirmValue);
            case 'oldPassword':
                return validateOldPassword(value, confirmValue);
            default:
                return '';
        }
    };

    const handleChange = (event) => {
        const passwordInput = inputRef.current;
        const value = event.target.value;
        onChange(event);

        const validateMessage = validatePassword(value, oldValue, confirmValue, validateType);
        const isPasswordValid = validateMessage === ''? true : false;
        passwordInput.classList.toggle('is-valid', isPasswordValid && passwordInput.checkValidity())
        passwordInput.classList.toggle('is-invalid', !isPasswordValid)

        if (!isPasswordValid) {
            passwordInput.setCustomValidity('Password must meet all requirements.');
            setValidationMessage(validateMessage);
        } else {
            passwordInput.setCustomValidity('')
        }
    };

    useEffect(() => {
        const passwordInput = inputRef.current;
        setValidationMessage(defaultMassage || '');
        if (resetMessage) {
            passwordInput.classList.toggle('is-valid', true);
            passwordInput.classList.toggle('is-invalid', false);
            passwordInput.setCustomValidity('');
            setResetMessage(false);
        }
    }, [resetMessage]);

    return (
        <div className={`input-group password-toggle ${size === 'sm' ? 'input-group-sm' : ''}`}>
            <input
                type={showPassword ? 'text' : 'password'}
                id={id}
                name={name}
                className="form-control"
                placeholder=""
                value={value}
                ref={inputRef}
                onChange={handleChange}
                required
            />
            <button
                type="button"
                onClick={handleTogglePasswordVisibility}
                aria-label=""
            >
            </button>
            {validationMessage && <div className="invalid-feedback">{validationMessage}</div>}
        </div>
    );
}

export default PasswordInput;